module.exports = __webpack_public_path__ + "img/applogo.bb20cd10.svg";